import React, { useState } from "react";
import Sidebar from "../admin/components/Sidebar"; 
import Header from "../admin/components/Header"; 

const AdminLayout = ({ children }) => {
  const [open, setOpen] = useState(false); 

  return (
    <div className="flex bg-gray-900">
      {/* Sidebar (for Admin) */}
      <Sidebar open={open} setOpen={setOpen} />

      {/* Main Content */}
      <div className="flex-1">
        {/* Admin Header */}
        <Header setOpen={setOpen} /> 
        <div className="pt-5 md:pt-2 ">{children}</div>
      </div>
    </div>
  );
};

export default AdminLayout;
